import React, {useState, useEffect} from "react";
import {VsiBubble, VsiH4} from "../../../../styled/App.styled";
import {useDataWithRoute, useTitleFromComponent} from "../../../../utils/hooks";
import {useVsiAppContext} from "../../../../stores/VsiApp";
import {Card} from "reactstrap";
import Grid from "../../../../components/Grid";
import Stockchart from "../../../../components/Stockchart";
import {formatStockChartConfig} from "../../../../utils/Helpers";
import {standardCapacityColors} from "../../../../utils/chartUtils";
import {useSearchParams} from "react-router-dom";
import {datastoreCapacityHistory} from "../../../../utils/gridColumnDefs/virtual/datastoreCapacityHistory";

export default function DatastoreCapacityHistory({context, title}) {
    useTitleFromComponent(`${context} / ${title}`);
    const { theme, client, periodId } = useVsiAppContext();
    const [searchParams] = useSearchParams();

    const [data] = useDataWithRoute(`/api/v6/report/virtual_datastore_history_for_esx_host_proc?client_id=${client.clientId}&period_id=${periodId}&esx_host_name=${encodeURI(searchParams.get('esx_host_name'))}&vcenter_name=${encodeURI(searchParams.get('vcenter_name'))}&cluster_name=${encodeURI(searchParams.get('cluster_name'))}`)

    const [utilTrendData, setUtilTrendData] = useState([]);

    useEffect(() => {
        handleStateWithData(data?.recordset);
    }, [data]);

    const handleStateWithData = (data) => {
        let sortedData = data?.sort(function (a, b) {
            return new Date(a.collection_date) - new Date(b.collection_date);
        });

        const allUtilTrends = formatStockChartConfig(sortedData || [], [
            {
                name: '% Utilization',
                field: 'pct_disk_used'
            }
        ]);

        setUtilTrendData(allUtilTrends.series);
    };

    const filterChanged = (eventData) => {
        let filteredData = [];
        eventData.api.forEachNodeAfterFilter(node => {
            filteredData.push(node.data);
        });

        handleStateWithData([filteredData]);
    };

    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>Datastore Capacity Usage History - {decodeURI(searchParams.get('esx_host_name')) || 'N/A'}</VsiH4>

            <VsiBubble>
                <Stockchart config={{colors: standardCapacityColors}}
                            saveParams={{
                                esxHostName: searchParams.get('esx_host_name'),
                            }}
                            series={utilTrendData}/>
            </VsiBubble>
            <VsiBubble>
                <Grid addStyle data={data?.recordsets?.[0] || []}
                      filterChanged={filterChanged}
                      columnDefs={datastoreCapacityHistory}/>
            </VsiBubble>
        </Card>
    )
}
